<template>
  <Transition name="dynamic-table__modal--unfold">
    <div class="dynamic-table__overlay" :data-flow-direction="flowDirection" @click="$emit('close')">
      <div class="dynamic-table__modal" :style="modalWidth ? ('--modal-width:' + modalWidth) : ''" @click.stop="">
        <div class="dynamic-table__selected">
          <div class="dynamic-table__header">
            <h5>Editando fila</h5>
            <button type="button" class="btn-light" :style="notClickToClose ? 'display: none;' : ''"
              @click="$emit('close')">
              <i class="fa fa-close"></i><span>Cerrar</span>
            </button>
          </div>
          <div class="dynamic-table__body">
            <h5 class="dynamic-table__title">
              {{ title }}
            </h5>
            <div class="dynamic-table__content" :data-has-vue-modal="hasVueModal ? 'true' : 'false'">
              <slot v-if="hasVueModal"></slot>
              <slot v-else :selectedRow="value"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: function () {
        return {};
      },
      required: false,
    },
    title: {
      type: String,
      require: true,
    },
    hasVueModal: {
      type: Boolean,
      require: false,
    },
    flowDirection: {
      type: String,
      require: true,
      default: "left",
    },
    modalWidth: {
      type: String,
      require: false,
    },
    notClickToClose: {
      type: Boolean,
      require: false,
    }
  },
  data: function () {
    return {
      selectedRow: false,
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$emit("close");
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/DynamicTable.vue